// export const InvoiceTableConfig: NeoTableConfig = {
//   title: "Invoices",
//   table: {
//     columns: [
//       {name: "S.No", uid: "sno", type: "value"},
//       {name: "Date", uid: "date", type: "value", sortable: true},
//       {name: "Invoice ID", uid: "invoiceId", type: "value", sortable: true},
//       {name: "Credits", uid: "credits", type: "value"},
//       {name: "Amount", uid: "amount", type: "value", sortable: true},
//       {name: "Status", uid: "status", type: "value"},
//       {name: "Payment Method", uid: "paymentMethod", type: "value"}
//     ],

//     activeColumns: [
//       "sno",
//       "date",
//       "invoiceId",
//       "credits",
//       "amount",
//       "status",
//       "paymentMethod"
//     ],

//     style: {
//       height: "h-full"
//     },

//     meta: {
//       id: 4,
//       title: "Manage Invoices",
//       description: "Total Invoices",
//       hasSearch: true,
//       hasUpload: true,
//       hasDownload: true,
//       hasAdd: false,
//       hasActions: true,
//       hasCheckbox: false,
//       hasFilter: false,
//       hasFooter: true,
//       hasHeader: true,
//       hasPagination: true,
//       hasCreate: false
//     },

//     url: {
//       api: {
//         get: "/api/invoices/list",
//         download: "/api/invoices/download"
//       }
//     }
//   }
// };

export const InvoiceTableConfig: NeoTableConfig = {
  title: "Invoices",
  table: {
    columns: [
      {name: "S.No", uid: "sno", type: "value"},
      {name: "Date", uid: "date", type: "value", sortable: true},
      {name: "Invoice ID", uid: "invoiceId", type: "value", sortable: true},
      {name: "Credits", uid: "credits", type: "value"},
      {name: "Amount", uid: "amount", type: "value", sortable: true},
      {name: "Status", uid: "status", type: "value"},
      {name: "Payment Method", uid: "paymentMethod", type: "value"}
    ],

    activeColumns: [
      "sno",
      "date",
      "invoiceId",
      "credits",
      "amount",
      "status",
      "paymentMethod"
    ],
    style: {
      height: "h-full"
    },
    meta: {
      id: 3,
      title: "Manage Invoices",
      description: "Total Invoices",
      hasSearch: true,
      hasUpload: true,
      hasDownload: true,
      hasAdd: false,
      hasActions: true,
      hasCheckbox: false,
      hasFilter: false,
      hasFooter: true,
      hasHeader: true,
      hasPagination: true,
      hasCreate: false
    },
    url: {
      page: {
        // view: "drivers/${navId}/view/driver-details",
        // add: "drivers/new/create/driver",
        // edit: "drivers/${navId}/edit/driver"
      },
      api: {
        // upload: "/api/drivers/upload",
        // download: "/api/drivers/download",
        // delete: "/api/drivers/delete",
        get: "/api/drivers/list"
        // deactivate: "/api/driver/status/update"
      }
    },
    actions: [
      {
        key: "view",
        label: "View",
        type: "navigate",
        isVisible: true
      }
    ]
  }
};
